import { BlogPostTemplateAdapter as BlogPostTemplate } from "./BlogPostTemplate";

export { BlogPostTemplate };
export type { BlogPostTemplateProps, BlogPostTemplateContent } from "./BlogPostTemplate.d";
